import { Box, Stack, Typography, Button } from "@mui/material";
export default function FeaturedProjectCard  (){
    return  (
  <Box 
    sx={{ 
      p: 2.5, 
      height: "100%",
      borderRadius: "24px", 
      background: "rgba(15, 23, 42, 0.4)", 
      backdropFilter: "blur(12px)",
      border: "1px solid rgba(59, 130, 246, 0.3)",
      display: "flex",
      flexDirection: "column",
      gap: 1.5
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="caption" sx={{ color: "#3b82f6", fontWeight: 700, letterSpacing: 1 }}>
        FEATURED PROJECT
      </Typography>
      <Box sx={{ px: 1, py: 0.2, borderRadius: "4px", bgcolor: "#27ae6020", color: "#27ae60", fontSize: "10px", fontWeight: 600 }}>
        LIVE
      </Box>
    </Stack>

    <Stack direction="row" spacing={2} alignItems="center">
      {/* Project Thumbnail Placeholder */}
      <Box 
        sx={{ 
          width: 80, height: 60, borderRadius: "12px", 
          background: "linear-gradient(135deg, #1e293b 0%, #3b82f6 100%)",
          flexShrink: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '20px'
        }}
      >
        🚀
      </Box>
      
      <Box>
        <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "15px" }}>
          SebFX Pro Platform
        </Typography>
        <Typography sx={{ color: "#94a3b8", fontSize: "11px", lineHeight: 1.3 }}>
          Automated trading dashboard with real-time Deriv API integration.
        </Typography>
      </Box>
    </Stack>

    <Button 
      variant="contained" 
      size="small"
      fullWidth
      href="https://sebfxpro.site"
      target="_blank"
      sx={{ 
        bgcolor: "#3b82f6", 
        borderRadius: "10px", 
        fontSize: "11px", 
        textTransform: "none",
        py: 1
      }}
    >
      View Case Study
    </Button>
  </Box>
);
}